
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loci",
      function () {
        return require("private-next-pages/loci/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loci"])
      });
    }
  